import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import DdAPI from '../components/API/DdAPI';

const CheckDDpayment = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { getRequest } = DdAPI();
    const { id = null, response = null } = useParams();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState(null);


    useEffect(() => {
        const loadPreData = async () => {
            if (id) {
                try {
                    const response = await getRequest(`dd_details/${id}`, {});
                    // console.log('response', response.data)
                    setFormData(response.data);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching data:', error);
                    throw error;
                }
            }

        };


        const checkPaymentStatus = async () => {
            try {
                const data = await loadPreData();
                // console.log('Ip', data)

                if (data.step >= 9) {
                    setLoading(false);
                } else {
                    navigate('/dashboard/dd');
                }

            } catch (error) {
                console.error('Error checking payment status:', error);
                navigate('/dashboard/dd');
            }
        };


        checkPaymentStatus();

    }, [navigate, location, id]);


    if (loading) {
        return <div>Loading...</div>; // or a spinner
    }

    return children;
};

export default CheckDDpayment;
